var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMySquare = function SvgIconMySquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.492 1.666H6.508c-3.033 0-4.841 1.808-4.841 4.842v6.975c0 3.041 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.809 4.842-4.842V6.508c.008-3.034-1.8-4.842-4.833-4.842m.966 5.875-1.95 6.283c-.466 1.492-2.558 1.517-3.05.034l-.583-1.725a1.58 1.58 0 0 0-1.008-1.009l-1.734-.583c-1.466-.492-1.45-2.6.042-3.05l6.283-1.958c1.233-.375 2.392.783 2 2.008"
  })));
};
export default SvgIconMySquare;